<template>
    <div>
      <div class="bottom">
          <div class="bottom_content">
            <div class="bottom_content_left">
              <img class="bottom_logo" :src="require('@/assets/img/logo_white.png')" alt="" />
              <div class="bottom_nav">
                <div class="bottom_nav_item"><span></span></div>
              </div>
              <div class="bottom_content_left_list">
                <div class="bottom_text">总部地址：<span>江苏省宿迁市沭阳县</span></div>
                <div class="bottom_text">服务热线：<span>18951524007</span></div>
              </div>
            </div>
            <div class="bottom_content_right">
              <div class="bottom_content_img">
                <img :src="require('@/assets/applet.png')" alt="" srcset="" />
                <div class="bottom_content_img_icon"></div>
                <div><span>扫码进入京递小程序</span></div>
              </div>
              <div class="bottom_content_img">
                <img :src="require('@/assets/official_account_dingyue.jpg')" alt="" srcset="" />
                <div class="bottom_content_img_icon"></div>
                <div><span>扫码关注微信订阅号</span></div>
              </div>
              <div class="bottom_content_img">
                <img :src="require('@/assets/douyinhao.png')" alt="" srcset="" />
                <div class="bottom_content_img_icon"></div>
                <div><span>扫码关注抖音账号</span></div>
              </div>
              <div class="bottom_content_img">
                <img :src="require('@/assets/kuaishouhao.png')" alt="" srcset="" />
                <div class="bottom_content_img_icon"></div>
                <div><span>扫码关注快手账号</span></div>
              </div>
              <!-- <div class="bottom_content_img">
                <img :src="require('@/assets/shipinghao.png')" alt="" srcset="" />
                <div class="bottom_content_img_icon"></div>
                <div><span>扫码关注微信视频账号</span></div>
              </div> -->
            </div>
          </div>
           <!-- ｜ 苏ICP备12009924号 -->
          <div class="bottom_version"><span>Copyright © 2023 沭阳县安可达运输中心 All Rights Reserved</span></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name:'Bottoms'
  }
  </script>
  
  <style lang="scss" scoped>
  .bottom{
      width: 100%;
      min-height: 456px;
      position: absolute;
      left: 0;
      bottom: 0;
      // background: url('~/assets/img/bottom_bg.png');
      background:url("../assets/img/bottom_bg.png") no-repeat;
      background-size: cover;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
  }
  .bottom_logo{
    width: 301px;
    height: 126px;
    margin-bottom: 35px;
  }
  .bottom_content_left_list{
    width: 550px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .bottom_text{
    color: rgba($color: #fff, $alpha: 0.25);
    font-size: 16px;
    font-weight: 400;
    span{
      color: #fff;
    }
  }
  .bottom_content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 24px 60px 0px 60px;
  }
  .bottom_content_img{
    width: 208px;
    margin-right: 59px;
    color: #fff;
    font-size: 16px;
    font-family: PingFangSC;
    text-align: center;
    img{
      width: 208px;
      height: 208px;
    }
    .bottom_content_img_icon{
      width: 10px;
      height: 10px;
      background: #FF8A00;
      clip-path: polygon(0 0, 100% 0, 50% 100%);
      transform: rotate(180deg);
      margin: 14px auto 10px auto;

    }
  }
  .bottom_version{
    border-top: 1px solid rgba($color: #fff, $alpha: 0.25);
    height: 95px;
    box-sizing: border-box;
    // padding-top: 34px;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    font-family: PingFangSC;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bottom_content_right{
    display: flex;
    align-items: flex-start;
  }
  </style>